export function NavigationFillIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
      <path
        fill="currentColor"
        d="M20.809 5.188c.6-1.273-.724-2.598-1.997-1.997L4.089 10.144C2.641 10.827 3.13 13 4.73 13H11v6.27c0 1.602 2.174 2.089 2.857.64L20.81 5.189z"
      ></path>
    </svg>
  );
}
